import axios, { AxiosResponse } from 'axios'
import { PaisList } from '_metronic/helpers'
import { IOption } from 'app/components'

const API_URL = process.env.REACT_APP_API_URL

/** Item do enum `TipoLogradouro` (`GET /tipos-logradouro`); `valor` é o código DNE. */
export type TipoLogradouroEnum = {
  name: string
  valor: string
  descricao: string
}

export type TipoLogradouroPaisValues = {
  tipoLogradouro?: IOption<string>
  pais?: IOption<number>
}

const PREPOSICOES = new Set(['de', 'da', 'do', 'das', 'dos', 'e'])

/** "RUA DE PEDESTRE" → "Rua de Pedestre". */
export const nomeTipoLogradouro = (nome: string) =>
  nome
    .toLocaleLowerCase('pt-BR')
    .split(' ')
    .map((palavra, i) =>
      i > 0 && PREPOSICOES.has(palavra)
        ? palavra
        : palavra.charAt(0).toLocaleUpperCase('pt-BR') + palavra.slice(1)
    )
    .join(' ')

let catalogo: Promise<TipoLogradouroEnum[]> | undefined

export const getTiposLogradouro = (): Promise<TipoLogradouroEnum[]> => {
  if (!catalogo) {
    catalogo = axios
      .get(`${API_URL}/tipos-logradouro`)
      .then((r: AxiosResponse<TipoLogradouroEnum[]>) => r.data)
      .catch((erro) => {
        catalogo = undefined
        throw erro
      })
  }
  return catalogo
}

export const getOptionsTiposLogradouro = async () => {
  const tipos = await getTiposLogradouro()
  // Numerados ("10ª Avenida") depois dos simples, para "Avenida" aparecer primeiro na busca.
  const ordenados = [
    ...tipos.filter((tipo) => !/^\d/.test(tipo.descricao)),
    ...tipos.filter((tipo) => /^\d/.test(tipo.descricao)),
  ]
  const options: IOption<string>[] = ordenados.map((tipo) => ({
    label: nomeTipoLogradouro(tipo.descricao),
    value: tipo.name,
  }))
  return { options, hasMore: false }
}

/** Rótulo de um tipo já gravado (a API do endereço devolve só o `name`). */
export const getRotuloTipoLogradouro = async (name: string) => {
  const tipo = (await getTiposLogradouro()).find((item) => item.name === name)
  return tipo ? nomeTipoLogradouro(tipo.descricao) : name
}

export const getPaisBrasil = async (): Promise<IOption<number> | undefined> => {
  const resp = await axios.get(`${API_URL}/paises?page=0&size=20&sort=nome&nome=BRASIL`)
  const paises: PaisList[] = resp.data?.data || []
  const brasil = paises.find((pais) => pais.nome?.toUpperCase() === 'BRASIL')
  return brasil ? { label: brasil.nome, value: brasil.id } : undefined
}

export const valoresIniciaisTipoLogradouroPais = (endereco?: {
  tipoLogradouro?: string | null
  pais?: PaisList | null
}): TipoLogradouroPaisValues => ({
  tipoLogradouro: endereco?.tipoLogradouro
    ? { label: endereco.tipoLogradouro, value: endereco.tipoLogradouro }
    : undefined,
  pais: endereco?.pais ? { label: endereco.pais.nome, value: endereco.pais.id } : undefined,
})

export const dtoTipoLogradouroPais = (values?: TipoLogradouroPaisValues) => ({
  tipoLogradouro: values?.tipoLogradouro?.value,
  pais: values?.pais?.value,
})
